class Config {
    /** API's endpoint */
    static API_URL = "https://tools.trackstreet.com/api/";
    static APP_URL = 'https://tools.trackstreet.com';
    static APP_ENV = 'production';

    /** Keycloak */
    static KEYCLOAK_URL = 'https://sso.trackstreet.com';
    static KEYCLOAK_REALM = 'ex-trackstreet';
    static KEYCLOAK_CLIENT_ID = 'tools-prod';

    /** Integrations */
    static GOOGLE_ANALYTICS_ID = 'G-HWRE4KGZT3';
    static BUGHERD_API_KEY = 'coczscbnaoily3g6tal59w';
}

export default Config;
